import { configureStore } from '@reduxjs/toolkit';

import { auditFacetSlice } from './reducers/auditFacet';
import { auditsSlice } from './reducers/audits';
import { channelFacetSlice } from './reducers/channelFacet';
import { gameFacetSlice } from './reducers/gameFacet';
import { reportFacetSlice } from './reducers/reportFacet';
import { createLogger } from 'redux-logger';

const store = configureStore({
	reducer: {
		auditFacet: auditFacetSlice.reducer,
		audits: auditsSlice.reducer,
		channelFacet: channelFacetSlice.reducer,
		gameFacet: gameFacetSlice.reducer,
		reportFacet: reportFacetSlice.reducer
	},
	middleware: (getDefaultMiddleware) => [...getDefaultMiddleware().concat(createLogger())]
});

export type RootState = ReturnType<typeof store.getState>;
export default store;
